import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterAssignedUsers',
})
export class FilterAssignedUsersPipe implements PipeTransform {

  transform(users:{id: number, isGroup?: boolean} [], assigned:  { userable:{id:number}, type:string} []): unknown {
    return users?.filter(x => this.isUserAlreadyAdded(x.id,
        assigned.map(x=> ({ id: x?.userable?.id, type: x?.type})),
        x.isGroup? 'groups' :'users') === false) ?? [];
  }
  private isUserAlreadyAdded (id:number, assigned: {id: number, type:string} [], type: string ='users'){
      return assigned.some((item) => item?.id == id && item?.type == type);
  }
}
